import { Routes, Route } from "react-router-dom";

import { useAuth } from "context/providers/auth";
import NotificationProvider from "context/providers/notifications";
import WorkersProvider from "context/providers/workers";
import CustomCommentsProvider from "context/providers/custom_comments";

import OtpAuthPanel from "components/OtpAuthPanel";
import ActivityProtect from "components/ActivityProtect";
import Loader from "components/Loader";
import Main from "components/Main";
import LoginPanel from "components/LoginPanel";

import NotFound from "views/404";
import CableProvider from "context/providers/cable";

const AppRouter = () => {
  const {
    state: { is_loading, otp_auth_needed, is_logged },
  } = useAuth();

  if (is_loading) {
    return <Loader />;
  }

  if (otp_auth_needed) {
    return (
      <Routes>
        <Route path="*" element={<OtpAuthPanel />} />
      </Routes>
    );
  }

  if (!is_logged) {
    return (
      <Routes>
        <Route path="/" element={<LoginPanel />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    );
  }

  return (
    <CableProvider>
      <ActivityProtect>
        <WorkersProvider>
          <CustomCommentsProvider>
            <NotificationProvider>
              <Main />
            </NotificationProvider>
          </CustomCommentsProvider>
        </WorkersProvider>
      </ActivityProtect>
    </CableProvider>
  );
};

export default AppRouter;
